import Vue from 'vue'
import VueRouter from 'vue-router'


//引入页面文件
import Overview from '@/views/overview/index.vue'

import Home from '@/views/home/index.vue'
import Article from '@/views/article/index.vue'
import ArticleDetail from '@/views/article/detail.vue'
import SingleImage from '@/views/single-image/index.vue'
import ImageText from '@/views/image-text/index.vue'
import TextList from '@/views/text-list/index.vue'
import TabList from '@/views/tab-list/index.vue'
import CoopPartner from '@/views/coop-partner/index.vue'
import ContactUs from '@/views/contact-us/index.vue'
import SearchResult from '@/views/searchPage/searchResult.vue'
import SearchDetail from '@/views/searchPage/detail.vue'

import Train from '@/train/home/index.vue'
import Article_2 from '@/train/article/index.vue'
import ArticleDetail_2 from '@/train/article/detail.vue'
import SingleImage_2 from '@/train/single-image/index.vue'
import ImageText_2 from '@/train/image-text/index.vue'
import TextList_2 from '@/train/text-list/index.vue'
import TabList_2 from '@/train/tab-list/index.vue'
import CoopPartner_2 from '@/train/coop-partner/index.vue'
import ContactUs_2 from '@/train/contact-us/index.vue'
import SearchResult_2 from '@/train/searchPage/searchResult.vue'
import SearchDetail_2 from '@/train/searchPage/detail.vue'

Vue.use(VueRouter)


//添加以下代码
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  // 首页
   {
    path: '/',
    name: 'Overview',
    component: Overview,
    meta: {
      title: '福建通文产业服务有限公司',
      content: {
        keywords: '',
        description: ''
      },
      breadcrumb: '首页'
    },
  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
     meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
  
  {
    path: '/article',
    name: 'Article',
    component: Article,
    meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
  {
    path: '/articleDetail',
    name: 'ArticleDetail',
    component: ArticleDetail,
    meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
  {
    path: '/singleImage',
    name: 'SingleImage',
    component: SingleImage,
    meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
  {
    path: '/imageText',
    name: 'ImageText',
    component: ImageText,
    meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
  {
    path: '/textList',
    name: 'TextList',
    component: TextList,
    meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
  {
    path: '/tabList',
    name: 'TabList',
    component: TabList,
    meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
   {
    path: '/coopPartner',
    name: 'CoopPartner',
    component: CoopPartner,
    meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
   {
    path: '/contactUs',
    name: 'ContactUs',
    component: ContactUs,
    meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
  {
    path: '/searchPage/searchResult',
    name: 'SearchResult',
    component: SearchResult,
    meta: {
      title: '结果列表',
      content: {
        keywords: '',
        description: ''
      },
      breadcrumb: '搜索结果',
    },

  },
  {
    path: '/searchPage/searchDetail',
    name: 'SearchDetail',
    component: SearchDetail,
    meta: {
      title: '文章详情',
      content: {
        keywords: '',
        description: ''
      },
      breadcrumb: '文章详情',
    },
  },
  {
    path: '/train',
    name: 'Train',
    component: Train,
    meta: {
      title: '首页',
      content: {
        keywords: '',
        description: ''
      },
      breadcrumb: '首页',
    },
  },
  {
    path: '/train/article',
    name: 'Article_2',
    component: Article_2,
    meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
  {
    path: '/train/articleDetail',
    name: 'ArticleDetail_2',
    component: ArticleDetail_2,
    meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
  {
    path: '/train/singleImage',
    name: 'SingleImage_2',
    component: SingleImage_2,
    meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
  {
    path: '/train/imageText',
    name: 'ImageText_2',
    component: ImageText_2,
    meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
  {
    path: '/train/textList',
    name: 'TextList_2',
    component: TextList_2,
    meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
  {
    path: '/train/tabList',
    name: 'TabList_2',
    component: TabList_2,
    meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
   {
    path: '/train/coopPartner',
    name: 'CoopPartner_2',
    component: CoopPartner_2,
    meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
   {
    path: '/train/contactUs',
    name: 'ContactUs_2',
    component: ContactUs_2,
    meta: {
      title: '',
      breadcrumb: '',
      requiresAuth: false
    },
  },
  {
    path: '/train/searchPage/searchResult',
    name: 'SearchResult_2',
    component: SearchResult_2,
    meta: {
      title: '结果列表',
      content: {
        keywords: '',
        description: ''
      },
      breadcrumb: '搜索结果',
    },

  },
  {
    path: '/train/searchPage/searchDetail',
    name: 'SearchDetail_2',
    component: SearchDetail_2,
    meta: {
      title: '文章详情',
      content: {
        keywords: '',
        description: ''
      },
      breadcrumb: '文章详情',
    },
  },
]

const router = new VueRouter({ 
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // 恢复滚动位置（浏览器后退时）
    } else {
      return { x: 0, y: 0 }; // 跳转到新页面时滚动到顶部
    }
  }
})

router.beforeEach(function (to, from, next) {
 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
  if (flag) {
    console.log(flag);
  // 如果是移动端设备，重定向到移动端首页
   window.location.href = 'https://mobile.fjtwfw.com/home';
} else {
  next(); //继续往后走
}
});

export default router
